import { Box, Progress, Text } from '@betterment/samba-react';

export const Header: React.FC<{ logoUrl?: string; progress?: number; title?: string }> = ({
  logoUrl,
  progress = 0,
  title,
}) => {
  return (
    <Box
      css={{
        py: 'space.300',
      }}
      style={{ gap: '16px', paddingLeft: '120px', paddingRight: '120px' }}
    >
      <Box css={{ display: 'flex', gap: 'space.200', pb: 'space.300' }}>
        {logoUrl && (
          <>
            <img src={logoUrl} alt="Advisor firm logo" />
            <Box css={{ width: '1px', height: '24px' }} style={{ backgroundColor: 'black' }} />
          </>
        )}
        <Text variant="text50" color="text.weak">
          {title}
        </Text>
      </Box>
      <Progress value={progress} indicatorColor="background.neutral.strong" style={{ backgroundColor: '#DBDBDB' }} />
    </Box>
  );
};
